<template>
    <div>
        <Modal
            id="modealDiv"
            ref="dialog"
            v-model="isShow"
            class-name="ivu-noPadding-wrap"
            transfer
            fullscreen
            :scrollable="true"
            :closable="closable"
            :footer-hide="footerHide"
            :mask-closable="false"
            :draggable=isMove
            :styles="{top: '0px',left: '0px'}"
            width="100%"
            @on-cancel="cancel">
            <p id="title" v-show="isTitle" :slot="customTitle" @mouseup="onMouseUps">
                <span>{{ titleName }}</span>
            </p>
            <div id="" style="width:0px;height:0px;position: absolute;">
                <svg
                    id="svgDom"
                    ref="svgNode"
                    style="width: 100%; height: 100%"
                    xmlns="http://www.w3.org/2000/svg"
                    @mousedown.capture="onMouseDown"
                    @mouseup.capture="onMouseUp"
                    @mouseenter.capture="onMouseEnter"
                    @mouseleave.capture="onMouseLeave"
                    @mousemove.capture="onMouseMove"
                >
                </svg>
                <component :is="item.component" v-for="item in primitivesList"
                           :primitives="item.primitives"
                           :fvSystemApi="item.fvSystemApi"
                           :parentObject="item.parentObject"
                           :key="item.registerName"></component>
            </div>
        </Modal>
        <div class="moveSvgDiv" @mousedown="leftClickKey" @mouseup="stopDiv" v-show="showDivSvg" ref="moveSvgDiv" @mousemove="move"></div>
    </div>
</template>
<style>
/*用于设置双击界面选中图片的bug*/
body {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}

#modealDiv .ivu-modal-wrap {
    overflow: hidden;
}

div .moveSvgDiv {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 5554;
}

.supportStyle:hover {
    cursor: grabbing !important;
}

/* 先注释掉， 影响app旋转后组件层级问题 */
.ivu-noPadding-wrap .ivu-modal-body {
    overflow: visible;
    padding: 0px;
}

.ivu-noPadding-wrap .ivu-modal-content {
    border-radius: 0;
    box-shadow: 0 0 0 0;
}

.ivu-modal-mask {
    background-color: rgba(55, 55, 55, 0);
}

#modealDiv .ivu-modal-header {
    padding: 0 !important;
}

#title {
    height: 51px;
    line-height: 51px;
    padding-left: 10px;
}

/* 用于流动动画 */
@keyframes runToLeft {
    from {
        stroke-dashoffset: 0%;
    }

    to {
        stroke-dashoffset: 100%;
    }
}

@keyframes runToRight {
    from {
        stroke-dashoffset: 100%;
    }

    to {
        stroke-dashoffset: 0%;
    }
}

/*滚动条样式*/
.ivu-modal-content::-webkit-scrollbar { /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
}

.ivu-modal-content::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
}

.ivu-modal-content::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
}
</style>
<script>
import Vue from 'vue';
import echarts from 'echarts';
import axios from 'axios';
Vue.prototype.$echarts = echarts;
import divUnit from '../../js/div/divUnit';
import fvSystemApi from '../../js/fvSystemApi';

export default {
    name: 'windowComponent',
    props: ['windowInfo'],
    created: function () {
        Object.assign(this, this.windowInfo);
        this.titleName = this.registerName;
        //系统风格会影响draw窗口的边框宽度，仅是显示问题。但是给用户的可视使用大小会比设置要小。
        //win7风格大约为20px。不同系统风格转义时会转义不同值。为转义默认为win7风格
        this.defaultTailoring = this.defaultTailoring ? parseInt(this.defaultTailoring) : 20;
        this.zoomMagnification();
        this.canvasWidth = (parseFloat(this.width) * this.scaleX) * devicePixelRatio;
        // this.canvasWidth = innerWidth;
        this.canvasHeight = (parseFloat(this.height) * this.scaleY) * devicePixelRatio;
        // this.canvasHeight = innerHeight;
        this.windowStyle = {
            top: this.y,
            left: this.x,
            width: this.$store.state.system.$.screenWidth,
            height: this.$store.state.system.$.screenHeight,
            textAlign: 'left',
            margin: '0 0px',
            padding: '0px'
        };
        if(window.addEventListener)
            window.addEventListener('DOMMouseScroll', document.onmousewheel, false);
        this.modelsPath = ['system', 'manager', this.registerName];
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this
            }
        });
        //此处保存了本模块的vuex对象，创建的子对象会加入到此，使前端脚本可以调用对象
        this.subObjects = this.$store.state.system.manager[this.registerName];
        //判断是否有标题 有标题加上标题的高度
        if(this.title) {
            this.heightTitle = 0;
            this.isTitle = true;
            this.customTitle = 'header';
            this.borderWid = 20;
            //判断是否可以拖动
            //先判断是否是标题窗口才有拖动条，才能设置是否拖动窗口
            if(this.dragger) {
                this.isMove = false;
            } else {
                this.isMove = true;
            }
        }
        //系统菜单
        if(this.menuMessage) {
            this.closable = this.menuMessage;
        }
        //用于弹出式窗口移动窗口前的初始值
        this.doFixEventTop = 0;
        this.doFixEventleft = 0;
        //用于存储移动窗口移动距离
        this.doFixEventOnMouseUp = {
            left: 0,
            top: 0
        };
        window.addEventListener('resize', () => {
            // 判断条件draw端还未添加
            if(0) {
                this.windowHeight = window.innerHeight;
                this.windowWidth = window.innerWidth;
            } else {
                this.$store.state.system.$.onResize();
            }
        });
        this.firstWindowHeight = window.innerHeight;
        this.firstWindowWidth = window.innerWidth;
    },
    async mounted() {
        this.svgNode = this.$refs.svgNode;
        this.init();
        this.iskko = false;
        this.isokk = false;
        if(this.fcchildren) {
            //先确定canvas大小。this.windowSize属性需要在对象常见时使用
            this.fcchildren.forEach(element => {
                if(element == undefined || element == null) {
                    return;
                }
                //draw边框导致所有图元需要按比例随访位置
                element.frameScaleX = this.defaultTailoring / this.width;
                element.frameScaleY = this.defaultTailoring / this.height;
                if(this.canvasWidth < (element.x + element.width) * this.scaleX) {
                    this.canvasWidth = (element.x + element.width) * this.scaleX;
                    this.iskko = true;
                }
                if(this.canvasHeight < (element.y + element.height) * this.scaleY) {
                    this.canvasHeight = (element.y + element.height) * this.scaleY;
                    this.isokk = true;
                }
            });
            var func = [];
            for (const element of this.fcchildren) {
                let i = this.fcchildren.indexOf(element);
                if(element == undefined || element == null) {
                    continue;
                }
                if(element.fctype === 'fvButton') {
                    element.fctype = 'fvButtonObj';
                }
                // 特殊情况处理（恢复老工程多折线lineType设置为立体管道，多折线不存在立体管道类型，所以转为管道类型绘制图元）
                if((element.fctype === 'fvPolygonObj' || element.fctype === 'fvPolylineObj') && element.lineType === -1) {
                    element.fctype = 'fvPipeObj';
                    // 转义json线宽为0，暂时按照现场bug设置为3
                    //element.borderWidth = 3;
                }

                func.push(await new Promise((resolve, rejected) => {
                    try {
                        if(Vue.component(element.fctype)) {
                            //if(element.fctype != "fvGroupObj"){
                            element.x += element.x * element.frameScaleX;
                            element.y += element.y * element.frameScaleY;
                            element.height += element.height * element.frameScaleY;
                            element.width += element.width * element.frameScaleX;
                            //}
                            this.primitivesList.push({
                                component: element.fctype,
                                primitives: element,
                                registerName: element.registerName,
                                parentObject: this,
                                fvSystemApi: new fvSystemApi(this.$store.state.system),
                            });
                            resolve();
                        } else {
                            this.parentX = 0;
                            this.parentY = 0;
                            new divUnit[element.fctype](element, this, this.svgNode, (obj) => {
                                this.subObjects[obj.name] = {
                                    '$': obj
                                };
                                this.zIndexObjList.push({
                                    name: obj.name,
                                    zIndex: obj.zIndex
                                });
                                resolve();
                            });
                        }

                    } catch (e) {
                        console.log('此类型不存在：%c' + element.fctype, 'color:#f00;');
                        console.log(e);
                        resolve();
                    }
                }));
            }
            Promise.all(func).then(() => {
                this.fcchildren.forEach((element, i) => {
                    if(element == undefined || element == null) {
                        return;
                    }

                    if(Vue.component(element.fctype)) {
                        this.primitivesList.forEach((e) => {
                            if(element.registerName == e.registerName) {
                                if(this.$store.state.system.manager[e.parentObject.registerName]) {
                                    this.subObjects[e.registerName] = this.$store.state.system.manager[e.parentObject.registerName][e.registerName];
                                }
                                this.zIndexObjList.push({
                                    name: element.registerName,
                                    zIndex: element.zIndex
                                });
                            }
                        });
                    }
                });
                this.zIndexObjList.sort(function (obj1, obj2) {
                    return obj1.zIndex - obj2.zIndex;
                });
                this.onSuccess();
            });
        }
    },
    data: function () {
        return {
            windowHeight: null,
            windowWidth: null, // 窗口变实时尺寸
            firstWindowHeight: null,
            firstWindowWidth: null, // 窗口首次渲染的尺寸
            titleName: '',
            isFocusWindow: false,
            winType: 'pc',
            styleZoom: {},//canvas 缩放样式
            modelsPath: [],
            spinShow: false,
            //关闭按钮
            closable: false,
            showDivSvg: false,
            //自定义标题
            customTitle: '',
            //判断是否拖动
            isMove: true,
            //标记点击的是否是关闭按钮
            iscancel: true,
            svgNode: null,//svg节点
            isNowClose: true,
            footerHide: true,
            isTitle: false,
            primitivesList: [],
            subObjects: {},
            lastTime: new Date().getTime(),
            isClose: false,
            isShow: false,
            zoom: 0,
            isZoom: false, //是否拖动对象
            domScale: {
                zoom: 0,
                x: this.y,
                y: this.x,
                sx: 1,
                sy: 1,
                ox: 0,
                oy: 0,
                scrollHeight: 0,
                scrollWidth: 0,
                titleHeight: 0
            },
            isOpenSuccess: false,
            zIndexObjList: [],
            //初始化对话框样式
            windowStyle: {
                top: 0,
                left: 0,
                textAlign: 'left',
                margin: '0 0',
                padding: '0px'
            },
            selected: null,
            heightTitle: 0,
            borderWid: 0,
            turn: 'selfAdaption',//"transverse"：横向 "portrait" ：纵向 "selfAdaption"：自适应
            openOtimer: true,//控制周期执行
            requestAnimationFrameInterval: new Date().getTime(),
            isOpneShow: true,
            mouseEnterDom: []
        };
    },
    watch: {
        windowHeight() {
            if(this.windowHeight !== this.firstWindowHeight) {
                // 差值
                let diff = (this.firstWindowHeight - this.windowHeight) / this.firstWindowHeight;
                // 新值
                let newY = (parseFloat(this.windowHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                let res = this.windowWidth - this.windowWidth * diff;
                let newX = parseFloat(res) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleX = newX;
                this.scaleY = newY;
                this.$store.state.system.$.onResize();
            }
            if(this.windowHeight == this.firstWindowHeight) {
                this.zoomMagnification();
                this.$store.state.system.$.onResize();
            }
        },
        windowWidth() {
            if(this.windowWidth !== this.firstWindowWidth) {
                // 差值
                let diff = (this.firstWindowWidth - this.windowWidth) / this.firstWindowWidth;
                // 新值
                let newX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                let res = this.windowHeight - this.windowHeight * diff;
                let newY = (parseFloat(res) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                this.scaleX = newX;
                this.scaleY = newY;
                this.$store.state.system.$.onResize();
            }
            if(this.windowWidth == window.screen.width) {
                this.zoomMagnification();
                this.$store.state.system.$.onResize();
            }
        },
    },
    methods: {
        setTitle(name) {
            this.titleName = name;
        },
        async init() {
            this.svgNode = this.$refs.svgNode;
            this.svgNode.style.width = this.canvasWidth + 'px';
            this.svgNode.style.height = this.canvasHeight + 'px';
            this.onDraw();
        },
        //弹出式窗口点击叉子调用
        cancel() {
            this.$parent.closeWindow(this.registerName);
            this.iscancel = false;
            // this.onClose();
        },
        /*
            参数：无
            作用：计算缩放比例
        */
        zoomMagnification() {
            if(isApp()) {
                var appTailoring = this.$store.state.system.$.appWinTitleHeight + this.$store.state.system.$.appWinSysHeight;
                this.scaleX = parseFloat(window.innerHeight - appTailoring) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY = (parseFloat(window.innerWidth) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight) + this.heightTitle);
            } else {
                this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }

            if(this.turn == 'portrait' || this.turn == 'transverse'|| this.turn == "portraits") {
                this.scaleX = 1;
                this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }
            if(this.$store.state.system.$.embedView == 1) {
                if(innerHeight > innerWidth) {
                    var rotate = 0;
                } else {
                    var rotate = 90;
                }
                if(rotate === 90) {
                    this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                    this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                } else {
                    this.scaleX = 1;
                    this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));

                }
            }
        },
        /*
            参数：无
            作用：获取缩放比例
        */
        getMagnification() {
            return {
                x: this.scaleX,
                y: this.scaleY
            };
        },
        /*
            参数：无
            作用：窗口加载完成
        */
        async onSuccess() {
            //因请求窗口json 使用延迟处理，所以进入窗口动作也要同步等待
            setTimeout(() => {
                this.fvScript.executionScript(this.entrancescript, undefined, this.registerName);
            }, 20);
            this.isOpenSuccess = true;
            if(this.turn == 'portrait' || this.turn == "portraits") {
                this.x += this.$store.state.system.$.zoomList.y;
                this.y += this.$store.state.system.$.zoomList.x;
            } else if(this.turn == 'transverse') {
                this.x += this.$store.state.system.$.zoomList.x;
                this.y += -this.$store.state.system.$.zoomList.y;
            } else if(this.turn == 'selfAdaption') {
                this.x += this.$store.state.system.$.zoomList.x;
                this.y += this.$store.state.system.$.zoomList.y;
            }
            this.repaint();
        },
        /*
            参数：time 当前时间
            作用：周期执行函数
        */
        onTimer(time) {
            if(!this.openOtimer) return;
            var currTime = new Date().getTime();
            if(currTime - this.lastTime > 200) {
                this.fvScript.executionScript(this.timerscript);
                this.lastTime = currTime;
                for (var i = 0; i < this.zIndexObjList.length; i++) {
                    var obj = this.zIndexObjList[i];
                    if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                        if(this.subObjects[obj.name].$.onTimer) {
                            this.subObjects[obj.name].$.onTimer(time);
                        }
                    }
                }
                this.onDraw();
                //用于判断绘制图元后再去显示窗口，只需要进入一次，以免后期调用show来隐藏窗口
                if(this.isOpneShow) {
                    this.isShow = true;
                    this.isOpneShow = false;
                    //单独设置msbox 层级，不能时候 this否则iview层级会根据打开窗口的顺组来设置曾加层级
                    if(document.getElementsByClassName('msboxStyle')[0]) {
                        document.getElementsByClassName('msboxStyle')[0].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.style.zIndex = this.$Modal.props.zIndex.default + 30;
                    }
                }

            }
        },
        /*
            参数：无
            作用：实时数据更新时被调用
        */
        onUpdata() {
            for (var p in this.subObjects) {
                if(p == '$') {
                    continue;
                }
                if(this.subObjects[p].$.onUpdata) {
                    this.subObjects[p].$.onUpdata();
                }
            }
        },
        /*
            参数：无
            作用：绘制界面
        */
        onDraw() {
            if(this.$refs.svgNode && this.$refs.svgNode.scrollTop) {
                this.domScale.scrollHeight = this.$refs.svgNode.scrollTop;
                this.domScale.scrollWidth = this.$refs.svgNode.scrollLeft;
            }
            if(this.spinShow) {
                this.spinShow = false;
            }
            for (var i = 0; i < this.zIndexObjList.length; i++) {
                var obj = this.zIndexObjList[i];
                if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                    if(this.subObjects[obj.name].$.type == 'basic' || this.subObjects[obj.name].$.type == 'group') {
                        try {
                            this.subObjects[obj.name].$.onDraw(this.subObjects[obj.name].$);
                        } catch (error) {
                            console.log('**********' + obj.name + '无onDraw函数**********');
                            console.log(error);
                        }
                    }
                }
            }
        },
        /*
            参数：无
            作用：窗口关闭前被调用
        */
        onClose() {
            this.openOtimer = false;
            var _this = this;
            return new Promise(function (resolve) {
                _this.fvScript.executionScript(_this.exitscript);
                var funcs = [];
                for (var p in _this.subObjects) {
                    if(p == '$') {
                        continue;
                    }
                    if(_this.subObjects[p].$.onClose) {
                        funcs.push(_this.subObjects[p].$.onClose());
                    }
                }
                Promise.all(funcs).then(() => {
                    _this.$el.removeChild(_this.$el.childNodes[0]);
                    resolve();
                });
            });
        },
        /*
            参数：isShow 显隐标记
            作用：设置窗口显隐
        */
        show(isShow) {
            this.isShow = isShow ? true : false;
        },
        setPosition(left, top) {
            if(this.turn == 'portrait'|| this.turn == "portraits") {
                this.x += -top;
                this.y += left;
            } else {
                this.x += left;
                this.y += top;
            }
            this.repaint();
        },
        repaint(info) {
            if(this.$refs == undefined || this.$refs.dialog == undefined) {return;}
            if(info == 'transverse' || info == 'vertical') {
                this.x = this.windowStyle.left;
                this.y = this.windowStyle.top;
                this.$store.state.system.$.screenWidth = this.windowStyle.width;
                this.$store.state.system.$.screenHeight = this.windowStyle.height;
            }else if(info=="reduction"){
                axios.get(window.debugFWebView + document.title+"/projectConf.json").then(function(result){
                    let dataSource=result.data;
                    this.x = this.windowStyle.left;
                    this.y = this.windowStyle.top;
                    this.$store.state.system.$.screenWidth = dataSource.screenWidth;
                    this.$store.state.system.$.screenHeight = dataSource.screenHeight;
                    this.zoomMagnification();
                    this.repaint();
                }.bind(this)).catch(function(error){
                    console.log(error)
                });
            } else if(info) {
                this.x += info.x;
                this.y += info.y;
            }
            //用于缩放 先百分百显示
            this.svgNode.style.zoom = 1;
            this.svgNode.style.width = (parseFloat(this.width) * this.scaleX) * devicePixelRatio;
            this.svgNode.style.height = (parseFloat(this.height) * this.scaleY) * devicePixelRatio;
            if(info) {
                if(isApp()) {
                    //全局缓存 svg
                    this.svgNode.style.width += 100;
                    this.svgNode.style.height += 100;
                } else {
                    //全局缓存 svg
                    this.svgNode.style.width += 15;
                    this.svgNode.style.height += 15;
                }
            }
            //在打开窗口获取鼠标位置且判断鼠标在点击区域获取到值
            if(this.centerOpen && window.onmousemoveY != undefined) {
                var y = parseFloat(window.onmousemoveY);
                var x = parseFloat(window.onmousemoveX);
                var w = (parseFloat(this.width) * this.scaleX);
                var h = (parseFloat(this.height) * this.scaleY);
                //缩放后大小
                var pos = {
                    'width': parseFloat(this.width) * this.scaleX + 'px',
                    //20是边框宽度
                    'height': (parseFloat(this.height) * this.scaleY) + (this.heightTitle * this.scaleY) + 'px',
                    'left': x + w / 2 - w + 'px',
                    'top': y + h / 2 - h + 'px'
                };
            } else {
                if(this.title) {
                    var titleHeight = 30;
                } else {
                    var titleHeight = 0;
                }
                //缩放后大小
                var pos = {
                    'width': parseFloat(this.width) * this.scaleX + 'px',
                    //20是边框宽度
                    'height': (parseFloat(this.height) * this.scaleY) + (titleHeight) + 'px',
                    'left': parseFloat(this.x) * this.scaleX + 'px',
                    'top': parseFloat(this.y) * this.scaleY + 'px'
                };
            }
            //是否全屏
            if(this.fullscreen) {
                //全屏重置缩放大小中的位置。（全屏时左上角坐标）
                pos = this.fullScreenShow();
            }
            //判断边框给与赋值后在高度减去
            var showApp = this.setWindowStyle(pos);
            if(this.$store.state.system.$.isZoom) {
                this.showDivSvg = true;
            } else {
                this.showDivSvg = false;
                this.$refs.moveSvgDiv.classList.remove('supportStyle');
            }
            if(this.title) {
                var titleHeight = -10;
            } else {
                var titleHeight = 0;
            }
            this.domScale = {
                zoom: this.zoom,
                x: parseFloat(pos.left),//窗口位置x
                y: parseFloat(pos.top),//窗口位置y
                sx: this.scaleX,//缩放比例x
                sy: this.scaleY,//缩放比例y
                ox: 0,//位置偏移x(滚轮缩放修改,已无用)
                oy: 0,//位置偏移y(滚轮缩放修改,已无用)
                titleHeight: titleHeight,//
                isApp: showApp,
                winType: 'pc',
                turn: this.turn,
                embedView: this.$store.state.system.$.embedView
            };
            this.$refs.dialog.$refs.content.parentElement.style.top = 0 + 'px';
            this.$refs.dialog.$refs.content.parentElement.style.left = 0 + 'px';
            this.reDraw();
            this.repaintStyle();
        },
        /*
            参数：无
            作用：界面计算后再次重绘样式

        */
        repaintStyle() {
            if(this.$refs.svgNode && this.$refs.svgNode.scrollTop) {
                this.domScale.scrollHeight = this.$refs.svgNode.scrollTop;
                this.domScale.scrollWidth = this.$refs.svgNode.scrollLeft;
            }
            if(this.spinShow) {
                this.spinShow = false;
            }
            for (var i = 0; i < this.zIndexObjList.length; i++) {
                var obj = this.zIndexObjList[i];
                if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                    if(this.subObjects[obj.name].$.type == 'basic' || this.subObjects[obj.name].$.type == 'group') {
                        try {
                            if(this.subObjects[obj.name].$.createStyle == undefined) continue;
                            this.subObjects[obj.name].$.createStyle(this.svgNode);
                        } catch (error) {
                            console.log('**********' + obj.name + '无onDraw函数**********');
                            console.log(error);
                        }

                    }
                }
            }
        },
        /*
            参数：无
            作用：重新计算位置(组件需要重绘)
        */
        reDraw() {
            for (var p in this.subObjects) {
                try {
                    if(p == '$') {
                        continue;
                    }
                    if(this.subObjects[p].$.reDraw) {
                        //属性display不存在或者不为block时，图元隐藏，不去绘制
                        if(!this.subObjects[p].$.display || this.subObjects[p].$.display == 'block') {
                            // 图元存在垂直水平移动动画后绘制  注：因如果添加此判断，调用放大所有，加有垂直动画的图元不能缩放
                            // if(this.subObjects[p].$.animation && this.subObjects[p].$.fctype.indexOf('Obj') >= 0 && (this.subObjects[p].$.animation.fvVerticalMove || this.subObjects[p].$.animation.fvHorMove)){
                            //   continue;
                            // }
                            this.subObjects[p].$.reDraw(this.domScale);
                        }
                    }

                } catch (error) {
                    console.log('**********' + p + ' reDraw函数**********');
                    console.log(error);
                }
            }
        },
        /*
            参数：无
            作用：全屏显示需要的设置
        */
        fullScreenShow() {
            var pos = {
                'width': window.innerWidth + 'px',
                'height': window.innerHeight - this.heightTitle + 'px',
                'left': '0px',
                'top': '0px'
            };
            this.scaleX = parseFloat(window.innerWidth) / (parseFloat(this.width)) + 0.01;
            this.scaleY = (parseFloat(window.innerHeight) - this.heightTitle) / (parseFloat(this.height) - 20);
            this.$refs.dialog.$refs.content.style.top = '0px';
            this.$refs.dialog.$refs.content.style.left = '0px';
            this.$refs.dialog.$refs.content.style.width = window.innerWidth + 'px';
            this.$refs.dialog.$refs.content.style.height = window.innerHeight + 'px';

            return pos;
        },
        //拖动窗口事件
        onMouseUps(e) {
            this.y = parseFloat(this.$refs.dialog.$refs.content.style.top) / this.scaleY;
            this.x = parseFloat(this.$refs.dialog.$refs.content.style.left) / this.scaleX;
            this.repaint();
        },
        stopDiv() {
            this.showDivSvg = false;
            this.$refs.moveSvgDiv.classList.remove('supportStyle');
            this.$store.state.system.$.isZoom = false;
        },
        leftClickKey(e) {
            if(e.button == 0) {
                this.$refs.moveSvgDiv.classList.remove('supportStyle');
            }
        },
        move(e) {
            if(this.showDivSvg == true) {
                this.$refs.moveSvgDiv.classList.add('supportStyle');
                this.$store.state.system.$.isZoom = true;
            }
        },
        /*
            参数：e 鼠标信息
            作用：鼠标按下时被调用
        */
        onMouseDown(e) {
            e.stopPropagation();
            for (const item of this.mouseEnterDom) {
                item.style.display = 'block';
                if(item.onmousedown == undefined) continue;
                item.onmousedown(e);
            }
        },
        /*
            参数：e 鼠标信息
            作用：鼠标弹起时被调用
        */
        onMouseUp(e) {
            e.stopPropagation();
            this.mouseEnterDom.forEach(item => {
                item.style.display = 'block';
                if(item.onmouseup == undefined) return;
                item.onmouseup(e);
            });
        },
        /*
            参数：e 鼠标信息
            作用：鼠标移动时被调用
        */
        onMouseMove(e) {
            e.stopPropagation();
            this.getMousePositionDom(e).forEach(item => {
                item.style.display = 'block';
                if(item.onmousemove == undefined) return;
                item.onmousemove(e);
            });
        },
        /*
            参数：e 鼠标信息
            作用：鼠标离开时被调用
        */
        onMouseLeave(e) {
            e.stopPropagation();
            this.mouseEnterDom.forEach(item => {
                item.style.display = 'block';
                if(item.onmouseleave == undefined) return;
                item.onmouseleave(e);
                this.mouseEnterDom = [];
            });
        },
        /*
            参数：e 鼠标信息
            作用：鼠标进入时被调用
        */
        onMouseEnter(e) {
            e.stopPropagation();
            // 防止打组触发两次
            if(e.target.tagName.toLowerCase() == 'svg') return;
            this.mouseEnterDom = this.getMousePositionDom(e);
            this.mouseEnterDom.forEach(item => {
                item.style.display = 'block';
                if(item.onmouseenter == undefined) return;
                item.onmouseenter(e);
            });
        },
        /*
            参数：e 鼠标信息
            作用：获取鼠标坐标下的元素
       */
        getMousePositionDom(e) {
            let x = e.clientX;
            let y = e.clientY;
            let domArr = [];
            (function getPositionDownDom() {
                let dom = document.elementFromPoint(x, y);
                if(dom == null || dom.getAttribute('id') == 'svgDom') {
                } else {
                    // 处理父级为g标签,并且方法在g标签上
                    if(dom.parentNode && dom.parentNode.tagName.toLowerCase() == 'g') {
                        domArr.push(dom.parentNode);
                    }
                    domArr.push(dom);

                    dom.style.display = 'none';
                    return getPositionDownDom();
                }
            }());
            this.noRepeat(domArr);
            return domArr;
        },
        // 数组去重
        noRepeat(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
                for (let j = i + 1; j < arr.length; j++) {
                    if(arr[i] === arr[j]) {
                        arr.splice(j, 1);
                        j--;
                    }
                }
            }
            return arr;
        },
        /*
            功能:鼠标坐标系转换
            参数:evt 鼠标信息
            返回值:无
        */
        mouseX(evt) {
            if(evt.pageX) return evt.pageX;
            else if(evt.clientX)
                return evt.clientX + (document.documentElement.scrollLeft ?
                    document.documentElement.scrollLeft :
                    document.body.scrollLeft);
            else return null;
        },
        /*
            功能:鼠标坐标系转换
            参数:evt 鼠标信息
            返回值:无
        */
        mouseY(evt) {
            if(evt.pageY) return evt.pageY;
            else if(evt.clientY)
                return evt.clientY + (document.documentElement.scrollTop ?
                    document.documentElement.scrollTop :
                    document.body.scrollTop);
        },
        /*
            参数：e 鼠标信息，type 鼠标错做类型，doFixEventOnMouseUp 用于传入移动窗口的距离
            作用：下发鼠标消息到各基本图元，处理修改鼠标样式
        */
        doFixEvent(e, type, doFixEventOnMouseUp) {
            var eventX = this.mouseX(e);
            var eventY = this.mouseY(e);
            var style = 'default';
            for (var p in this.subObjects) {
                if(p == '$') continue;
                if(this.subObjects[p].$.type == 'basic') {
                    this.subObjects[p].$[type](e, this.domScale, doFixEventOnMouseUp);
                    //判断是否有动画， 如果有动画进入
                    if(this.subObjects[p].$.isAnimation) {
                        if(type == 'onMouseMove'
                            && this.subObjects[p].$.isHasAnimation(['fvLmousescript', 'fvRmousescript', 'fvMousescript'])
                            && this.subObjects[p].$.mouseState) {
                            style = 'pointer';
                            break;
                        }
                    }
                } else if(this.subObjects[p].$.doFixEvent) {

                    if(this.subObjects[p].$.isAnimation) {
                        this.subObjects[p].$[type](e, this.domScale, doFixEventOnMouseUp);
                        var p1 = this.subObjects[p].$.isHasAnimation(['fvLmousescript', 'fvRmousescript', 'fvMousescript']);
                        var p2 = this.subObjects[p].$.mouseState;
                        if(type == 'onMouseMove'
                            && p1
                            && p2) {
                            style = 'pointer';
                            break;
                        } else {
                            var subStyle = this.subObjects[p].$.doFixEvent(e, type, doFixEventOnMouseUp);
                        }
                    } else {
                        this.subObjects[p].$[type](e, this.domScale, doFixEventOnMouseUp);
                        var subStyle = this.subObjects[p].$.doFixEvent(e, type, doFixEventOnMouseUp);
                        //为打组添加点击事件 状态
                        if(this.subObjects[p].$.type == 'group') {
                            var leftX = this.subObjects[p].$.x + +this.domScale.x;
                            var rightX = leftX + this.subObjects[p].$.regionWidth;
                            var topY = this.subObjects[p].$.y + this.domScale.titleHeight + this.domScale.y;
                            var bottomY = this.subObjects[p].$.regionHeight + topY;
                            if(eventX < rightX
                                && eventX > leftX
                                && eventY < bottomY
                                && eventY > topY) {
                                subStyle = 'pointer';
                            } else {
                                subStyle = 'default';

                            }
                        }
                    }
                    if(style == 'default') {
                        style = subStyle;
                    }
                }
            }
            if(type == 'onMouseMove') {
                this.ctx.canvas.style.cursor = style;
            }
        },
        /*
            参数：obj 选中的对象
            作用：设置当前窗口选中的对象
        */
        select(obj) {
            this.selected = obj;
        },
        /*
            参数：无
            作用：设置窗口边框风格
        */
        setWindowStyle(pos) {
            if(this.$refs == undefined || this.$refs.dialog == undefined) {return;}
            let width = this.canvasWidth > parseInt(pos.width) ? this.canvasWidth * this.scaleX + 'px' : pos.width;
            let height = this.canvasHeight > parseInt(pos.height) ? this.canvasHeight * this.scaleY + 'px' : pos.height;
            this.$refs.dialog.$refs.content.style.backgroundColor = this.borderColor;
            var result = isApp();
            if(this.$store.state.system.$.embedView != 1) {
                if(result) {
                    if(this.turn == 'transverse' || this.turn == 'portrait'|| this.turn == "portraits") {
                        this.setPcWindowStyle(pos);
                    } else {
                        this.setAppWindowStyle(pos);
                    }
                } else {
                    this.setPcWindowStyle(pos);
                }
            } else {
                this.setPcWindowStyle(pos);
            }
            //设置canvas 宽高
            var solidWidth = 0;
            if(this.borderWidth == 2) {
                this.$refs.dialog.$refs.content.style.border = '5px solid #85ABE4';
                solidWidth = 10;
            } else if(this.borderWidth == 1) {
                this.$refs.dialog.$refs.content.style.border = '2px solid #85ABE4';
                solidWidth = 4;
            } else {
                this.$refs.dialog.$refs.content.style.border = '0px solid #85ABE4';
            }
            this.svgNode.parentElement.style.width = pos.width;
            this.svgNode.parentElement.style.height = pos.height;
            var svgLeftX = window.innerWidth - parseFloat(pos.left) - this.heightTitle;
            var svgTopY = window.innerHeight - parseFloat(pos.top) - this.heightTitle;
            var overflowX = 0;
            var overflowY = 0;
            if(parseFloat(pos.height) > svgTopY) {
                this.svgNode.parentElement.style.height = svgTopY + 'px';
            }
            if(parseFloat(pos.width) > svgLeftX) {
                this.svgNode.parentElement.style.width = svgLeftX + 'px';
            }
            if(this.isTitle) {
                //有滚动条。设置canvas的高度和宽度
                if(this.scroll) {
                    if(!this.iskko && !this.isokk) {
                        if(isApp()) {
                            this.svgNode.parentElement.style.overflow = 'visible';
                        } else {
                            //根据图元的位置判断是否添加滚动条
                            if(parseFloat(this.svgNode.parentElement.style.height) < parseFloat(this.canvasHeight)) {
                                this.svgNode.parentElement.style.overflow = 'auto';
                            } else {
                                this.svgNode.parentElement.style.overflow = 'hidden';
                            }
                        }
                    } else {
                        this.svgNode.parentElement.style.overflow = 'auto';
                    }

                    this.svgNode.style.height = this.canvasHeight - this.heightTitle + 20;
                    this.svgNode.style.width = this.canvasWidth + 20;
                } else {
                    if(isApp()) {
                        this.svgNode.parentElement.style.overflow = 'visible';
                    } else {
                        this.svgNode.parentElement.style.overflow = 'hidden';
                    }
                    this.svgNode.style.height = (parseFloat(pos.height) - solidWidth) * devicePixelRatio + 1;
                    this.svgNode.style.width = (parseFloat(pos.width) - solidWidth) * devicePixelRatio;
                    this.svgNode.parentElement.style.height = (parseFloat(pos.height) - solidWidth) * devicePixelRatio + 1 + 'px';
                    this.svgNode.parentElement.style.width = (parseFloat(pos.width) - solidWidth) * devicePixelRatio + 'px';
                }
            } else {
                if(this.scroll) {
                    if(!this.iskko && !this.isokk) {
                        if(isApp()) {
                            this.svgNode.parentElement.style.overflow = 'visible';
                        } else {
                            //根据图元的位置判断是否添加滚动条
                            if(parseFloat(this.svgNode.parentElement.style.height) < parseFloat(this.canvasHeight)) {
                                this.svgNode.parentElement.style.overflow = 'auto';
                            } else {
                                this.svgNode.parentElement.style.overflow = 'hidden';
                            }
                        }
                    } else {
                        this.svgNode.parentElement.style.overflow = 'auto';
                    }

                    this.svgNode.style.height = this.canvasHeight + 20;
                    if(this.canvasHeight > 1500) {
                        this.svgNode.style.height = this.canvasHeight + 20;
                    }
                    this.svgNode.style.width = this.canvasWidth + 20;
                } else {
                    if(isApp()) {
                        this.svgNode.parentElement.style.overflow = 'visible';
                    } else {
                        this.svgNode.parentElement.style.overflow = 'hidden';
                    }
                    this.svgNode.style.height = (parseFloat(pos.height) - this.heightTitle - solidWidth) * devicePixelRatio + 21;
                    this.svgNode.style.width = (parseFloat(pos.width) - solidWidth) * devicePixelRatio + 20;
                }
            }
            //清空，否则拖动事件位置不对
            this.$refs.dialog.$refs.content.parentNode.style.width = '';
            //因app打开pc窗口 旋转90度后，按钮置后显示的bug
            if(result && this.$refs.dialog.$refs.content.style.transform == 'rotate(90deg)') {
                this.$refs.dialog.$refs.content.style.overflow = 'auto';
            }
            // this.$refs.dialog.$refs.content.children[0].children[0].style.width = pos.width;
            // this.$refs.dialog.$refs.content.children[0].children[0].style.height = pos.height;
            //加20的 滚动条的宽度
            // this.svgNode.style.width = this.canvasWidth + overflowX +"px";
            // this.svgNode.style.height = this.canvasHeight + overflowY +"px";
            return result;
        },
        setPcWindowStyle(pos) {
            if(this.turn == 'transverse') {
                this.$refs.dialog.$refs.content.style.width = pos.width;
                this.$refs.dialog.$refs.content.style.height = pos.height;
                this.$refs.dialog.$refs.content.style.top = -parseFloat(pos.height) + parseFloat(pos.left) + 'px';
                this.$refs.dialog.$refs.content.style.left = window.innerWidth - parseFloat(pos.height) - parseFloat(pos.top) + 'px';
                this.$refs.dialog.$refs.content.style.transform = 'rotate(90deg)';
                this.$refs.dialog.$refs.content.style.transformOrigin = '0% 100% 0';
            } else {
                this.$refs.dialog.$refs.content.style.top = pos.top;
                this.$refs.dialog.$refs.content.style.left = pos.left;
                this.$refs.dialog.$refs.content.style.width = pos.width;
                this.$refs.dialog.$refs.content.style.height = parseFloat(pos.height) + this.heightTitle + 'px';
            }
            ;
        },

        setAppWindowStyle(pos) {
            this.$refs.dialog.$refs.content.style.width = pos.width;
            this.$refs.dialog.$refs.content.style.height = pos.height;
            this.$refs.dialog.$refs.content.style.top = -parseFloat(pos.height) + this.$store.state.system.$.appWinTitleHeight + parseFloat(pos.left) + 'px';
            this.$refs.dialog.$refs.content.style.left = window.innerWidth - parseFloat(pos.height) - parseFloat(pos.top) + 'px';
            this.$refs.dialog.$refs.content.style.transform = 'rotate(90deg)';
            this.$refs.dialog.$refs.content.style.transformOrigin = '0% 100% 0';
        },

        cleanUpFource() {
            this.isFocusWindow = false;
        },

        setFourceWindow() {
            this.isFocusWindow = true;
            this.$store.state.system.manager.$.setFocusWindow(this.registerName);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/system/windowComponentDiv.vue